var mapViewModel = {

    map: null,

    currentLat: null,
    currentLng: null,

    lastLatFetched: null,
    lastLngFetched: null,

    serviceSelectedType: ko.observable('search'),

    searchText: ko.observable(''),

    bsHeaderResultDropdown: null,

    poolsSearchResult: ko.observableArray(),

    poolsData: null,

    poolMarkersLayer: null,

    locateControl: null,

    showMap: function () {
        // $('#raychat_main').hide();
    },

    refreshPoolsMarker: function () {
        let markers = this.poolsData.pools;
        this.poolMarkersLayer.clearLayers();

        // if (this.map.getZoom() < 13)
        //     return;

        for (var i = 0; i < markers.length; i++) {

            // If pool is disable show black & white marker icon on map
            if (markers[i]['status_sell'])
                markerIconUrl = 'https://cdn.poolticket.org/assets/dist/images/pool-marker.png';
            else
                markerIconUrl = 'https://cdn.poolticket.org/assets/dist/images/pool-marker-black-and-white.png';

            let marker = new L.marker(L.latLng(parseFloat(markers[i]['lat']), parseFloat(markers[i]['lng'])), {
                    icon: L.icon({
                        iconUrl: markerIconUrl,
                        iconSize: [40, 50],
                        iconAnchor: [20, 50],
                        poolId: markers[i]['pool_id'],
                        indexId: i,
                        zIndexOffset: 1000
                    })
                })
                .bindPopup(this.getPoolPopupTemplate(markers[i]), {
                    offset: [0, -30]
                });

            this.poolMarkersLayer.addLayer(marker);
        }

        this.map.addLayer(this.poolMarkersLayer);
    },

    getPoolPopupTemplate: function (pool) {
        return `<div style="width:200px">
            <figure class="position-relative m-1">
                <img class="img-fit rounded rounded-4 pool-card-image" src="${pool.image}">
                <div class="position-absolute cover-img-info text-end">
                    <h2 class="fs-6 mb-0 mt-4 pt-1 pe-2">${pool.name}</h2>
                    <span class="text-muted pe-2 fs-7">${pool.address}</span>
                    <div class="text-info d-flex mt-1 p-0 me-2">
                        <div class="rate-box mt-0">
                            <div class="five-stars-container fs-6">
                                <div class="five-stars" style="width: ${pool.rate * 100 / 5}%"></div>
                            </div>
                        </div>
                        <div class="mt-1 me-1 small text-light">${pool.rate.toString().toPersianDigits()}</div>
                    </div>
                </div>
            </figure>
            <div class="pt-4 mt-4 text-center">
                <div class="mb-2 text-primary text-center">
                    ${pool.status_sell ?
                        `
                        <span class="fs-7 ps-1"> شروع قیمت از</span>
                        <span class="fw-bold fs-6">${pool.minimum_sale_price ? pool.minimum_sale_price.toString().toPersianDigits() : ''}</span>
                        `
                        :
                        `
                        <span class="fs-7 ps-1">غیرفعال</span>
                        `
                    }
                </div>
                ${pool.status_sell ?
                    `<a class="btn btn-primary rounded-3 py-1 px-4 mb-3" target="_blank" href="${pool.url}">مشاهده جزئیات</a>`
                    :
                    `<a class="btn btn-secondary text-white rounded-3 py-1 px-4 mb-3" target="_blank" href="${pool.url}">مشاهده جزئیات</a>`
                }
            </div>
        </div>`;
    },

    loadPools: function (force) {
        let lat = this.currentLat;
        let lng = this.currentLng;

        // Load new pools in map moved for 1 kilometers
        if (!force) {
            if (mapViewModel.lastLatFetched) {
                let distance = L.latLng(lat, lng).distanceTo(L.latLng(mapViewModel.lastLatFetched, mapViewModel.lastLngFetched));
                if (distance < 1000) {
                    return;
                }
            }
        }

        let url = `/${this.serviceSelectedType()}?map=true&lat=${lat}&lng=${lng}&limit=100&sort=nearest`;

        var that = this;
        $.ajax({
            url: url,
            method: 'GET',
            dataType: 'json'
        })
        .done(function (data) {
            if (data.status == 1) {
                that.poolsData = data;
                that.refreshPoolsMarker();
                that.lastLatFetched = lat;
                that.lastLngFetched = lng;
            }
        });
    },

    attachMapMove: function () {
        this.map.on('moveend', function (e) {
            mapViewModel.currentLat = this.map.getCenter().lat;
            mapViewModel.currentLng = this.map.getCenter().lng;
            this.loadPools();
        }, this);
    },

    attachLocateControl: function () {
        this.locateControl = L.control.locate({
            position: 'topleft',
        }).addTo(this.map);
    },

    locate: function() {
        this.locateControl.start();
    },

    attachZoomControl: function () {
        L.control.zoom({
            position: 'topleft'
        }).addTo(this.map);
    },

    loadMap: function () {
        zoom = 15;

        var that = this;

        // let osm = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        //     attribution: 'Map data © <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        // });

        const token = "pk.eyJ1IjoibWpjaCIsImEiOiJjbG0wZjRsamIwOTI1M3BzNjRvOGR3emdnIn0.BRa8AbypMKKKPIxHhJGQiw";
        const mapboxUrl = "https://api.mapbox.com/styles/v1/mapbox/streets-v10/tiles/{z}/{x}/{y}@2x?access_token=" + token;
        let mapbox = new L.TileLayer(mapboxUrl, {
            attribution: 'Map data © <a href="http://osm.org/copyright">OpenStreetMap</a> contributors. Tiles from <a href="https://www.mapbox.com">Mapbox</a>.',
            tileSize: 512,
            zoomOffset: -1
        });

        let mapOptions = {
            layers: [mapbox],
            // layers: [osm],
            center: [that.currentLat, that.currentLng],
            zoom: zoom,
            minZoom: 5,
            maxZoom: 18,
            zoomControl: false,
        };

        that.map = new L.Map('map', mapOptions);

        that.poolMarkersLayer = L.layerGroup();

        that.attachZoomControl();
        that.attachLocateControl();
        that.attachMapMove();
        that.loadPools();
    },

    initMap: function () {
        var that = this;

        if (that.map === null) {
            that.loadMap();
            that.showMap();
            setTimeout(function(){ that.map.invalidateSize(true)}, 250);
        } else {
            that.showMap();
            setTimeout(function(){ that.map.invalidateSize(true)}, 250);
        }
    },

    init: function () {
        let searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('lat') && searchParams.has('lng')) {
            if (searchParams.get('lat').length > 0 && searchParams.get('lng').length > 0) {
                this.currentLat = searchParams.get('lat');
                this.currentLng = searchParams.get('lng');
            }
        }

        if (!this.currentLat) {
            // Default location is Tehran
            this.currentLat = 35.68816;
            this.currentLng = 51.39257;
            // this.currentLat = 36.30108055263433;
            // this.currentLng = 59.598898887634284;
        }

        this.bsHeaderResultDropdown = new bootstrap.Dropdown(document.getElementById('header-search-q-input'));
    },

    setServiceSelectedType: function(serviceType) {
        this.serviceSelectedType(serviceType);
        this.loadPools(true);
    },

    searchInputChanged: function(model, e) {
        const q = e.target.value;
        const city = document.getElementById("header-search-city-input").value;

        let url = `/${this.serviceSelectedType()}`
        if (city !== 'all') {
            url = url + `/${city}`;
        }

        url = url + `?q=${q}&category_link=true`;

        if (q.length > 1) {
            $.ajax({
                url: url,
                method: 'get',
                dataType: "json",
                cache: false
            }).done(function (data) {
                if (data.status && data.pools.length > 0) {
                    model.poolsSearchResult.removeAll();
                    $.each(data.pools, function (index, s) {
                        model.poolsSearchResult.push(s);
                    });
                }

                if (model.poolsSearchResult().length > 0) {
                    document.getElementById("header-result-dropdown-map").style.visibility = ""
                }
            });
        }
    },

    loadPool: function(pool) {
        mapViewModel.map.panTo(new L.LatLng(pool.lat, pool.lng));
    },
};

ko.applyBindings(mapViewModel, document.getElementById('map-page'));

mapViewModel.init();
mapViewModel.initMap();

function getQueryParams(qs) {
    qs = qs.split('+').join(' ');

    var params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }
    return params;
}

getWindowSize = function () {
    var w, h, win = window, doc = document;
    var body = doc.body;

    // Old IE
    if (body.offsetWidth) {
        w = body.offsetWidth;
        h = body.offsetHeight;
    }

    // Modern browsers
    if (win.innerWidth && win.innerHeight) {
        w = win.innerWidth;
        h = win.innerHeight;
    }

    return { w: w, h: h };
}